import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpStatusCode,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError, Observable, switchMap, throwError } from 'rxjs';
import { AuthApi } from '../api/auth.api';
import { Router } from '@angular/router';

@Injectable()
export class ApiTokenInterceptor implements HttpInterceptor {
  constructor(
    private authApi: AuthApi,
    private router: Router
  ) {}

  intercept<T>(request: HttpRequest<T>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    return next
      .handle(this.addAccessToken(request))
      .pipe(catchError((error: HttpErrorResponse) => this.handleApiError<T>(error, request, next)));
  }

  private handleApiError<T>(
    error: HttpErrorResponse,
    request: HttpRequest<T>,
    next: HttpHandler
  ): Observable<HttpEvent<T>> {
    if (error.status === HttpStatusCode.Unauthorized && !/logout$/.test(error.url || '')) {
      if (this.authApi.getRefreshToken()) {
        return this.refreshToken(request, next);
      }

      this.logout();
    }

    return throwError(() => error);
  }

  private refreshToken<T>(request: HttpRequest<T>, next: HttpHandler): Observable<HttpEvent<T>> {
    return this.authApi.refreshToken().pipe(
      switchMap(({ accessToken }) => {
        const transformedRequest: HttpRequest<T> = this.addAccessToken<T>(request, accessToken);
        return next.handle(transformedRequest);
      }),
      catchError(error => {
        this.logout();

        return throwError(() => error);
      })
    );
  }

  private logout(): void {
    this.router.navigate(['auth']);
  }

  private addAccessToken<T>(request: HttpRequest<T>, token?: string): HttpRequest<T> {
    const accessToken: string | null = token || this.authApi.getAccessToken();
    return request.clone({ setHeaders: { Authorization: `Bearer ${accessToken}` } });
  }
}
